import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

export type WabaSignupEventInput = {
  /** Meta's own event name (`ERROR`, `CANCEL`) or one of ours, lowercased. */
  event: string;
  currentStep?: string | null;
  errorId?: string | null;
  sessionId?: string | null;
  errorMessage?: string | null;
};

/**
 * Reports an Embedded Signup attempt that ended without a `FINISH`.
 *
 * Fire-and-forget: the flow has already failed by the time this runs, and the operator is looking
 * at Meta's reason on screen. A failure to file the report must never become a second error on top
 * of the first, so it has no `onError` and nothing awaits it. There is no success counterpart —
 * a completed signup is recorded by `useConnectWaba`.
 */
export function useRecordWabaSignupEvent() {
  return useMutation({
    mutationFn: (input: WabaSignupEventInput) =>
      api.post<null>("/crm/whatsapp/waba/signup-event", input),
  });
}
